import(/* webpackMode: "eager", webpackExports: ["PremiumHero"] */ "/app/src/components/templates/employer/premium-page/PremiumHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TalentPremiumUpgrade"] */ "/app/src/components/templates/talent/premium-page/TalentPremiumUpgrade.tsx");
